import { ThreeDots } from "react-loader-spinner";
import { useSelector } from "react-redux";

const Loading = () => {
  const { MAIN_COLOR } = useSelector((state) => state.CONFIG);

  return (
    <ThreeDots
      height="90"
      width="90"
      radius="9"
      color={MAIN_COLOR}
      ariaLabel="three-dots-loading"
      wrapperStyle={{}}
      wrapperClass="ajax-loader"
      visible={true}
    />
  );
};

export default Loading;
